import { colors } from "@indeed/ifl-tokens";
import { useCallback, useRef } from "react";
import type { View } from "react-native";

import { Button, Share } from "../../../../../../mads";
import { useI18n } from "../../../../../../shared/I18n";
import { logTapButton } from "../../../../../../shared/native-modules/tare/logTapButton";
import { useViewjobOneGraphModel } from "../../../../context/ViewJobDataContext";
import { useShareJob } from "./useShareJob";

export interface ShareButtonProps {
  ariaLabel?: string;
  disabled?: boolean;
  renderWhenUnavailable?: boolean;
  variant?: "tertiary" | "utility";
}

export function ShareButton({
  ariaLabel,
  disabled,
  renderWhenUnavailable = false,
  variant = "tertiary",
}: ShareButtonProps): React.JSX.Element | null {
  const i18n = useI18n();
  const model = useViewjobOneGraphModel();
  const shareButtonRef = useRef<View>(null);
  const shareJob = useShareJob();

  const handleShare = useCallback(() => {
    if (disabled || !model?.shareModel) {
      return;
    }

    logTapButton("rn-view-job", "share").catch(console.error);

    shareJob(model.shareModel, shareButtonRef.current).catch((error) => {
      console.error("Share failed:", error);
    });
  }, [disabled, model, shareJob]);

  if (model?.job?.isVisibilityUnlisted) {
    return null;
  }

  if (model?.shareModel == null && !renderWhenUnavailable) {
    return null;
  }

  return (
    <Button
      variant={variant}
      testID={"share-button"}
      onPress={handleShare}
      disabled={disabled || model?.shareModel == null}
      ariaLabel={ariaLabel ?? i18n.gettext("Share job")}
      iconOnly={true}
      size="md"
      iconAfter={<Share color={colors.foreground.strong} />}
      ref={shareButtonRef}
    />
  );
}
